import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import lodash from 'lodash';
import deepdash from 'deepdash';
const _ = deepdash(lodash);

import { commonStore } from "./commonStore";
import { authorizationStore } from "./authorizationStore";
import { classificationStore } from "./classificationStore";
import { store as canvasDesignStore } from "./canvasDesignStore";
import commons from "../commons/commons";
import Axios from "axios";
import webAppConfig from "../commons/webApp.config";
import LocalStorageService from "./LocalStorageService";

const getInitialState = () => ({
  ...commonStore.state,
  workspace: {},
  workspaceModules: [],
  workspaceContext: null,
  availableModules: [],
  module: {},
  moduleImport: {},
  list: {},
  basket: [],
  miniStudio: false,
  designMode: false,
  designModeLoading: false,
  designModeState: null
});

export const clientStore = new Vuex.Store({
  state: getInitialState(),
  mutations: {
    ...commonStore.mutations,
    resetState(state) {
      Object.assign(state, getInitialState());
    },
    setMiniStudio(state, value) {
      state.miniStudio = value;
    },
    designMode(state, data) {
      state.designMode = data;
      if (!data) {
        state.designModeState = null;
        state.miniStudio = false;
      }
    },
    designModeLoading(state, data) {
      state.designModeLoading = data;
    },
    designModeState(state, data) {
      state.designModeState = data;
    },
    setWorkspace(state, data) {
      if (
        !Boolean(window.router) ||
        (
          window.router &&
          window.router.currentRoute &&
          window.router.currentRoute.name !== 'shareForm'
        )
      ) {
        $cookies.set('wsId', data.id);
        LocalStorageService.setWorkspaceId(webAppConfig.baseServer, data.id);

        if (!authorizationStore.getters.isRunAs) {
          LocalStorageService.setWorkspace(webAppConfig.baseServer, data);
        }
      }
      state.client.defaults.headers['wsId'] = data.id;
      if (data.demoId) {
        state.client.defaults.headers['wsId'] = `demo:${data.id}:${data.demoId}`;
      } else if (authorizationStore.getters.isRunAs) {
        state.client.defaults.headers['wsId'] = authorizationStore.state.runAs.wsId;
      }

      state.workspace = data;
      state.workspaceModules = data.vectors;

      if (!state.workspace.hasContext) {
        state.workspaceContext = null;
      }
      /* set workspace name */
      classificationStore.dispatch("setWorkspace", data.name);
      /* set users */
      classificationStore.dispatch('setUsers', { users: data.users });
      canvasDesignStore.dispatch('setUsers', data.users);
    },
    setModule(state, data) {
      state.module = data;
    },
    setList(state, data) {
      state.list = data;
    },
    setWorkspaceName(state, data) {
      state.workspace.name = data;
      LocalStorageService.setWorkspace(webAppConfig.baseServer, state.workspace);
    },
    setWorkspaceUsers(state, data) {
      state.workspace.users = data;
      // set users
      classificationStore.dispatch("setUsers", { users: data });
      canvasDesignStore.dispatch("setUsers", data);
    },
    setWorkspaceMenus(state, data) {
      state.workspace.menus = data;
    },
    setWorkspaceContext(state, data) {
      $cookies.set('wsContext', data);
      state.workspaceContext = data;
    },
    setWorkspaceWidget(state, data) {
      state.workspace = data;
      LocalStorageService.setWorkspace(webAppConfig.baseServer, data);
    },
    setWorkspaceStates(state, data) {
      state.workspace.states = data;
    }
  },
  actions: {
    ...commonStore.actions,
    resetState({ commit }) {
      commit('resetState');
    },
    setMiniStudio({ commit }, mode) {
      commit("setMiniStudio", mode);
    },
    setDesignMode({ commit, getters }, { mode, skipLog }) {
      commit('designMode', Boolean(mode));
      if (!skipLog && getters.moduleId) {
        LocalStorageService.setModuleListingPreference(
          getters.moduleId,
          getters.listId,
          {
            ...LocalStorageService.getModuleListingPreference(getters.moduleId, getters.listId),
            designMode: Boolean(mode)
          }
        )
      }
    },
    setDesignModeLoading({ commit }, val) {
      commit('designModeLoading', Boolean(val));
    },
    setDesignModeState({ commit }, val) {
      commit('designModeState', val);
    },
    setWorkspaceModuleStates({ commit, getters }, payload) {
      const states = payload.states.map((x) => ({...x, module: payload.moduleId.toString()}));
      if (Array.isArray(getters.workspaceStates)) {
        commit('setWorkspaceStates', 
          [
            ...getters.workspaceStates.filter((x) => x.module != payload.moduleId),
            ...states
          ]
        );
      } else {
        commit('setWorkspaceStates', states);
      }
    },
    setWorkspace({ state, commit }, payload = {}) {
      try {
        let workspace = payload.workspace;
        let cloneWorkspaceMenus = null;

        authorizationStore.dispatch('setRoles', workspace.roles);

        if (authorizationStore.getters.isAdminUser) {
          const menuEverything = { id: "everything", name: "Everything", emoji: "🗃️" };
          workspace.vectors = workspace.vectors.map(x => {
            if (x.menus.length) {
              let findMenuEverything = x.menus.find(y => y.id == "everything");
              if (findMenuEverything) {
                findMenuEverything = {...findMenuEverything, ...menuEverything};
              } else {
                return {
                  ...x,
                  menus: [...x.menus, {...menuEverything}]
                }
              }
            }

            return x;
          });
        }

        commons.expandMenu(workspace.menus, workspace.vectors);
        
        if (payload.preserveMenuState)
          cloneWorkspaceMenus = _.cloneDeep(state.workspace.menus);

        if (payload.demoId)
          workspace.demoId = payload.demoId;

        commit('setWorkspace', workspace);

        if (workspace && workspace.hasContext) {
          const context = $cookies.get('wsContext');
          context && commit('setWorkspaceContext', context);
        }

        if (payload.preserveMenuState) {
          if (cloneWorkspaceMenus && Array.isArray(cloneWorkspaceMenus))
            commons.setOpenedMenus(state.workspace.menus, cloneWorkspaceMenus);

          if ((state.list && state.list.parentId) || state.module && state.module.id)
            commons.expandSidebarMenu(
              state.module.id ? state.module.id : state.list.parentId,
              state.workspace.menus
            );
        }

        const flattenWorkspaceMenuModules = (menus) => {
          return menus.flatMap(menu => [
            ...(menu.module !== undefined ? [menu.module] : []),
            ...(menu.children ? flattenWorkspaceMenuModules(menu.children) : [])
          ]);
        }

        state.availableModules = flattenWorkspaceMenuModules(state.workspace.menus);
      } catch(err) {
        throw err;
      } 
    },
    async loadWorkspaceShareForm({ commit }, payload) {
      try {
        let route = payload.route;
        let res = await Axios.get(`${webAppConfig.baseURL}/api/workspace/0`, {
          headers: {
            Authorization: `inishare ${payload.route.params.id}:${payload.route.query.code}`
          }
        })
        commit('setWorkspace', res.data)
      } catch (err) {
        throw err
      }
    },
    async loadWorkspace({ state, dispatch }, payload = {}) {
      try {
        let workspaceId = payload.id || $cookies.get('wsId');
        if (!workspaceId) {
          const res = await dispatch('getWorkspaces', { search: '' });
          if (Array.isArray(res) && res[0] && res[0].id) {
            workspaceId = res[0].id;
          } else {
            throw {
              status: 404,
              error: 'No workspace found. Please contact your administrator.'
            };
          }
        }

        let url = `/api/workspace/${workspaceId}`;
        let lsWorkspaceData = {};

        if (!payload.forceReload) {
          lsWorkspaceData = LocalStorageService.getWorkspace(webAppConfig.baseServer, workspaceId);
          if (lsWorkspaceData && lsWorkspaceData.id && lsWorkspaceData.version && (lsWorkspaceData.id == workspaceId)) {
            url += `?version=${lsWorkspaceData.version}`;
          }
        }

        const res = await state.client.get(url);
        const workspace = res.data && res.data.id ? res.data : lsWorkspaceData;

        dispatch('setWorkspace', { ...payload, workspace: workspace });
      } catch (err) {
        console.error(err);

        if ($cookies.get('wsId')) {
          $cookies.remove('wsId');
        }

        if (LocalStorageService.getWorkspaceId(webAppConfig.baseServer)) {
          LocalStorageService.removeWorkspaceId(webAppConfig.baseServer);
        }

        LocalStorageService.clearWorkspace(webAppConfig.baseServer);
        throw err;
      }
    },
    async loadWorkspaceUsers({ state }, payload) {
      try {
        const res = await state.client.get(`/api/workspace/${payload.id}`);
        return res.data.users;
      } catch(err) {
        throw err;
      }
    },
    async loadDiagram({ state }, payload) {
      return await state.client.get(`/api/workspace/diagram/${commons.decodeids(payload)}`);
    },
    async trace({ state }, payload) {
      return await state.client.get(`/api/activity/trace/${payload}`);
    },
    async updateLobby({ state }, payload) {
      return await state.client.post(`/api/user/lobby`, payload);
    },
    async acceptRejectUser({ state }, payload) {
      return await state.client.post(`/api/user/lobbyApproval`, payload);
    },
    async loadDocumentInputs({ state }, payload) { /* never read */
      return await state.client.get(`/api/activity/documentinputs?moduleid=${payload.moduleId}&templateid=${payload.tempalteId}`);
    },
    setWorkspaceName({ commit }, payload) {
      commit('setWorkspaceName', payload);
    },
    setWorkspaceMenus({ commit }, payload) {
      commit('setWorkspaceMenus', payload);
    },
    /* dashboard widget */
    async setWorkspaceWidget({ state, commit }, payload) {
      let workspace = { ...state.workspace };
      if (payload.hasOwnProperty('shortcuts')) {
        workspace.shortcuts = payload.shortcuts;
      }
      if (payload.hasOwnProperty('widgets')) {
        workspace.widgets = payload.widgets;
      }
      if (payload.hasOwnProperty('dashboard')) {
        workspace.dashboard = payload.dashboard;
      }
      commit('setWorkspaceWidget', workspace);
    },
    async updateDashboardWidget({ state, getters }, payload) {
      const shortcuts = payload && payload.shortcuts ? payload.shortcuts : _.cloneDeep(getters.workspaceShortcuts);
      const widgets = payload && payload.widgets ? payload.widgets : _.cloneDeep(getters.workspaceWidgets);
      const dashboard = payload && payload.dashboard ? payload.dashboard : _.cloneDeep(getters.workspaceDashboard);
      return await state.client.post('/api/workspace/updatedashboard', {
        id: getters.workspaceId,
        shortcuts,
        widgets,
        dashboard
      });
    },
    //export request
    async exportRequest({ state, commit, dispatch }, payload) {
        return await state.client.post('/api/document/exportRequest', payload);
    },
    //from listview, todo: to be refactor
    async loadWorkspaceModule({ state, commit, dispatch }, payload) {
      const moduleId = commons.decodeids(payload.moduleId)
      try {
        /* workspace */
        if (_.isEmpty(state.workspace) || !state.workspaceModules.find(x => x.id == moduleId)) {
          let res = await state.client.get(`/api/workspace/0?vector=${moduleId}`);
          authorizationStore.dispatch('setRoles', res.data.roles);
          commons.expandMenu(res.data.menus, res.data.vectors)
          dispatch('setWorkspace', { workspace: res.data });
        }
        /* module */
        let module = state.workspaceModules.find(x => x.id == moduleId)
        if (module)
          commit('setModule', module)
        /* list */
        if (payload.listId) {
          const list = _.findDeep(state.workspace.menus, (value, key, parentValue, context) => 
            commons.isObject(parentValue) && parentValue.id == moduleId && value.id == payload.listId, 
          { childrenPath: 'children'});
          if (list && list.value && list.parent && list.parent.id && list.parent.type != 'group') {
            commit('setList', {
              id: list.value.id,
              name: list.value.name,
              emoji: list.value.emoji,
              parentId: list.parent.id
            })
          } else {
            commit('setList', {})
          }
        } else {
          commit('setList', {})
        }
        /* expand sidebar menu */
        if ((state.list && state.list.parentId) || state.module && state.module.id) {
          let workspaceMenus = _.cloneDeep(state.workspace.menus)
          commons.expandSidebarMenu(
            state.module.id ? state.module.id : state.list.parentId,
            workspaceMenus
          )
          state.workspace.menus = workspaceMenus;
        }
      } catch (err) {
        throw err;
      }
    },
    resetModule({ commit }) {
      commit('setModule', {});
      commit('setList', {});
    },
    async getWorkspaces({ state }, payload) {
      const search = payload && payload.search ? encodeURIComponent(payload.search) : "";
      try {
        let res = await state.client.get(`/api/workspace?search=${search}`)
        return res.data || []
      } catch (err) {
        console.error(err)
        return []
      }
    },
    async getFirstOrDefaultWorkspaceId({ dispatch }) {
      const res = await dispatch('getWorkspaces', { search: '' });
      return res && res[0] && res[0].id;
    },
    async loadDocumentForm({ state }, payload) {
      return await state.client.post('/api/activity/form', payload);
    },
    async sendInvitation({ state }, payload) {
      return await state.client.post('/api/workspace/invites', payload);
    },
    async getInvitationLink({ state }, payload) {
      try {
        let res = await state.client.post('/api/workspace/invites', payload);
        return res.data
      } catch (err) {
        throw err
      }
    },
    /* workspace context */
    setWorkspaceContext({ commit }, payload) {
      commit('setWorkspaceContext', payload)
    },
    async getWorkspaceContexts({ state, getters }, payload) {
      try {
        let res = await state.client.get(`/api/workspace/context?id=${getters.workspaceId}&search=${payload.search}`)
        return res.data || []
      } catch (err) {
        console.error(err)
        return []
      }
    },
    /* list view */
    async loadWorkspaceList({ state }, payload) {
      return await state.client.post('/api/workspace/list', payload);
    },
    /* dashboard */
    async retrieveDashboard({ state }, payload) {
      return await state.client.get(`/api/workspace/dashboard?activityeveryone=${payload.activityEveryone}`);
    },
    /* widget */
    async previewWidget({ state }, payload) {
      return await state.client.post(`/api/workspace/previewWidget/`, payload);
    },
    /* widget */
    async retrieveWidget({ state }, payload) {
      if (
        window.router &&
        window.router.currentRoute &&
        window.router.currentRoute.meta &&
        window.router.currentRoute.meta.external
      ) {
        const query= window.router.currentRoute.query;
        let wsId = query.id;
        if(query.runas){
          wsId = `runas:${query.id}:${query.runas}`;
        }

        return await Axios.post(`${webAppConfig.baseURL}/api/workspace/widget/${payload.itemId}`, payload.filters, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${query.token}`,
            "tz": Intl.DateTimeFormat().resolvedOptions().timeZone,
            "wsId": wsId
          }
        });
      } else {
        return await state.client.post(`/api/workspace/widget/${payload.itemId}`, payload.filters);
      }
    },
    /* notification */
    async retrieveNotification({ state }, payload) {
      return await state.client.post('/api/workspace/notifications', payload);
    },
    async retrieveNotificationCount({ state }) {
      return await state.client.get('/api/workspace/notificationcount')
    },
    async clearNotificationUnreceivedCount({ state }) {
      return await state.client.get('/api/workspace/clearnotificationunreceived')
    },
    /* htmlTemplate */
    async htmlTemplateProcess({ state }, payload) {
      return await state.client.get(`/service/htmltemplateprocessing/document?documentmodel=${encodeURIComponent(payload)}`)
    },
    /* my calendar */
    async getMyCalender({ state }, payload) {
      return await state.client.post('/api/workspace/calendar', payload)
    },
    async setMyCalendarEvent({ state }, payload) {
      return await state.client.post('/api/workspace/addtomycalendar', payload)
    },
    /* solution */
    async loadWorkspaceSolutions({ state }, payload) {
      return Boolean(payload.search) ?
        await state.client.get(`/api/workspace/solutions?search=${encodeURI(payload.search)}`) :
        await state.client.get('/api/workspace/solutions');
    },
    async loadAISolution({ state }, payload) {
      return await state.client.get(`/api/ai?type=system&text=${encodeURI(payload.search)}&count=${payload.count}`);
    },
    /* user */
    setWorkspaceUser({ getters, commit }, payload) {
      let workspaceUsers = [...getters.workspaceUsers];
      const userIndex = workspaceUsers.findIndex(user => user.username == payload.username);
      if (userIndex !== -1) {
        workspaceUsers[userIndex] = payload;
        commit("setWorkspaceUsers", workspaceUsers);
      }
    },
    removeWorkspaceUser({ getters, commit }, payload) {
      let workspaceUsers = [...getters.workspaceUsers];
      const userIndex = workspaceUsers.findIndex(user => user.username == payload);
      if (userIndex !== -1) {
        workspaceUsers.splice(userIndex, 1);
        commit("setWorkspaceUsers", workspaceUsers);
      }
    },
    /* member */
    async getMember({ state }, payload) {
      return await state.client.get(`/api/user/list?search=${encodeURI(payload.searchDisplayName)}&type=${encodeURI(payload.type)}`)
    },
    async loadLobby({ state }, payload) {
      return await state.client.get(`/api/user/lobby`)
    },
    async updateMember({ state }, payload) {
      return await state.client.post('/api/user/updatedetail', payload)
    },
    async resetUserPassword({ state }, payload) {
      return await state.client.post('/api/user/resetpassword/', payload)
    },
    async setDisableEnable({ state }, payload) {
      return await state.client.post('/api/user/disableenable', payload)
    },
    async unlockUser({ state }, payload) {
      return await state.client.post('/api/user/unlock', payload)
    },
    async setRole({ state }, payload) {
      return await state.client.post('/api/user/setRole', payload)
    },
    async loadHistory({ state }, payload) {
      return await state.client.get(`/api/activity/historyitem/${payload.type},${payload.id}`);
    }
  },
  getters: {
    workspaceId: state => state.workspace && state.workspace.id,
    workspaceName: state => state.workspace && state.workspace.name,
    workspaceBeta: state => Boolean(state.workspace && state.workspace.beta),
    workspaceModules: state => state.workspace && state.workspace.vectors,
    workspaceStates: state => state.workspace && state.workspace.states,
    workspaceUsers: state => state.workspace && state.workspace.users,
    workspaceShortcuts: state => state.workspace && state.workspace.shortcuts,
    workspaceWidgets: state => state.workspace && state.workspace.widgets,
    workspaceDashboard: state => state.workspace && state.workspace.dashboard,
    workspaceMenus: state => state.workspace && state.workspace.menus,
    workspaceCountry: state => state.workspace && state.workspace.country,
    workspaceBuilder: state => Boolean(state.workspace && state.workspace.builder),
    workspaceLobby: state => Boolean(state.workspace && state.workspace.inLobby),
    availableModules: state => Array.isArray(state.availableModules) ? state.availableModules : [],
    companyName: state => state.workspace && state.workspace.company && state.workspace.company.name,
    companyLogo: state => state.workspace && state.workspace.company && state.workspace.company.logo,
    module: state => state.module,
    moduleId: state => state.module && state.module.id,
    moduleStates: (state, getters) =>
      getters.moduleId && getters.workspaceStates && getters.workspaceStates.filter(
        x => x.module == getters.moduleId
      )
    ,
    list: state => state.list,
    listId: state => state.list && state.list.id,
    miniStudio: state => state.miniStudio,
    designMode: state => state.designMode,
    designModeLoading: state => state.designModeLoading,
    designModeState: state => state.designModeState
  }
});